import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { NgForm, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { User } from '../../shared/models/users';
import { UsersService } from '../../shared/services/users.service';
import { ResetPasswordService } from '../../shared/services/resetPassword.service';
import { UtilitiesService } from '../../shared/services/utilities.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  userData: User;
  buttonOptions: any = {
    text: 'Actualizar datos',
    type: 'default',
    useSubmitBehavior: true,
  };
  uploadForm: FormGroup;

  constructor(
    private utilitiesService: UtilitiesService,
    private usersService: UsersService,
    private resetPasswordService : ResetPasswordService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    const userData = JSON.parse(localStorage.getItem('udta'));
    // console.log(userData);
    // Funsion temporal *************************** 
    this.usersService.getUserAsPromise(userData.id).then(user => {
      this.userData = user;
      console.log(this.userData);

    }).catch(error => {
      console.log(error);
    })
    // Funcion Fila real ***********************
    // this._subscriptions.push(
    //   this.usersService.getUser(userData.id).subscribe(user => {
    //     this.userData = user;
    //     console.log(this.userData); 
    //   })
    // )
  }

  resetPassword(){
    this.resetPasswordService.resetPasswordInit(this.userData.email);
  }
  onFormSubmit() {
    console.log(this.userData);
    localStorage.setItem('udta', JSON.stringify(this.userData));
    this.usersService.updateUser(this.userData).subscribe(res => {
      this.utilitiesService.notifyMeAndRedirect('Ejecutado exitosamente!', 'success', '/dash/profile');
    }), (error => {
      this.utilitiesService.notifyMe(error, 'error');
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
